interface Props {
  color?: string;
  bg?: string;
}

const CertificateIcon: React.FC<Props> = ({
  color = "#2977EC",
  bg = "white",
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.98131 1.86743C9.51391 1.23885 10.4834 1.23885 11.016 1.86743L11.6577 2.62491C11.9843 3.01036 12.5006 3.17814 12.9914 3.05826L13.9558 2.82267C14.7562 2.62717 15.5405 3.19702 15.6019 4.01857L15.6758 5.00861C15.7135 5.5124 16.0326 5.95165 16.5001 6.14313L17.4188 6.51941C18.1812 6.83164 18.4808 7.75371 18.0476 8.45444L17.5255 9.29884C17.2598 9.72857 17.2598 10.2715 17.5255 10.7012L18.0476 11.5456C18.4808 12.2464 18.1812 13.1684 17.4188 13.4806L16.5001 13.857C16.0326 14.0484 15.7135 14.4877 15.6758 14.9914L15.6019 15.9815C15.5405 16.803 14.7562 17.3729 13.9558 17.1774L12.9914 16.9418C12.5006 16.8219 11.9843 16.9897 11.6577 17.3752L11.016 18.1326C10.4834 18.7612 9.51391 18.7612 8.98131 18.1326L8.33958 17.3752C8.01298 16.9897 7.49665 16.8219 7.00585 16.9418L6.04143 17.1774C5.24112 17.3729 4.45678 16.803 4.3954 15.9815L4.32144 14.9914C4.2838 14.4877 3.96467 14.0484 3.49716 13.857L2.57844 13.4806C1.81606 13.1684 1.51647 12.2464 1.94971 11.5456L2.4718 10.7012C2.73747 10.2715 2.73747 9.72857 2.4718 9.29884L1.94971 8.45444C1.51647 7.75371 1.81606 6.83164 2.57844 6.51941L3.49716 6.14313C3.96467 5.95165 4.2838 5.5124 4.32144 5.00861L4.3954 4.01857C4.45678 3.19702 5.24112 2.62717 6.04143 2.82267L7.00585 3.05826C7.49665 3.17814 8.01298 3.01036 8.33958 2.62491L8.98131 1.86743Z"
        fill={color}
      />
      <path
        d="M9.0013 11.7502L7.2513 10.0002L6.66797 10.5835L9.0013 12.9168L14.0013 7.91683L13.418 7.3335L9.0013 11.7502Z"
        fill={bg}
      />
    </svg>
  );
};

export default CertificateIcon;
